// extracted by mini-css-extract-plugin
module.exports = {"board-flag-container":"FlagIcon_board-flag-container__i3gt0"};